export default __webpack_public_path__ + "static/media/cv_sebastien_santerre.c3f388fb.pdf";